import script from "./LardoAlertDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./LardoAlertDialog.vue?vue&type=script&setup=true&lang=js"

import "./LardoAlertDialog.vue?vue&type=style&index=0&id=747e4a04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-747e4a04"]])

export default __exports__